import { useQuery } from 'react-query';
import { useContext } from 'react';
import { FetchContext } from 'context/FetchContext';

function useReorderPlayableList(data = {}) {
  const { enabled = true, queryKey = ['playable-reorder'], podcastId, episodeId } = data;
  const { privateFetch } = useContext(FetchContext);

  const fetchReorderPlayables = async () => {
    if (!podcastId || !episodeId) {
      throw new Error('podcastId and episodeId are required');
    }

    const response = await privateFetch.get(
      `/v1/admin/podcast/${podcastId}/episode/${episodeId}/playables/reorder`
    );
    return response?.data?.data || [];
  };

  return useQuery(queryKey, fetchReorderPlayables, {
    enabled: enabled && !!podcastId && !!episodeId,
    keepPreviousData: false,
    cacheTime: 0,
    staleTime: 0,
    refetchOnWindowFocus: false,
    refetchOnMount: true,
  });
}

export default useReorderPlayableList;
